import React, { useState, useEffect } from 'react';
import { 
  Fab, 
  useTheme, 
  alpha,
  Zoom,
  useScrollTrigger
} from '@mui/material';
import { 
  KeyboardArrowUp as KeyboardArrowUpIcon 
} from '@mui/icons-material';

const BackToTop = () => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  // 监听滚动事件
  useEffect(() => {
    const toggleVisibility = () => {
      // 当页面滚动超过一屏高度时显示按钮
      if (window.pageYOffset > window.innerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // 添加滚动监听器
    window.addEventListener('scroll', toggleVisibility);

    // 清理监听器
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // 平滑滚动到顶部
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Zoom in={isVisible}>
      <Fab
        onClick={scrollToTop}
        size="medium"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          boxShadow: theme.shadows[8],
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            transform: 'scale(1.1)',
            boxShadow: `0 8px 25px ${alpha(theme.palette.primary.main, 0.4)}`,
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        aria-label="回到顶部"
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};

export default BackToTop;
